


















import { Vue, Component } from "vue-property-decorator";
import TestPassResult from "@/components/tests/TestPassResult.vue";
import { TestPassResult as ITestPassResult } from "@/api/models/test-pass-result";
import api from "@/getinfo-api";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({ components: { CBreadCrumbs, TestPassResult } })
export default class TestPassResultView extends Vue {
  testPass!: ITestPassResult | any;
  showSpinner: boolean = true;

  data() {
    return {
      testPass: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "testResult" },
        label: this.$tc(this.$translate.ResultsOfTests)
      },
      {
        label: this.$converter.limitedOutput(this.testPass.title, 40)
      }
    ];
  }

  getTestPassResult() {
    api.TestPassApi.getResult(this.$route.params.testPassId).then(
      (res: { data: ITestPassResult }) => {
        this.showSpinner = false;
        this.testPass = res.data;
      }
    );
  }

  created() {
    this.getTestPassResult();
  }
}
